import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { DefaultForm } from "../../components";
import { GlanceAdjustmentMarkCollectModel } from "../../entities/glance";
import { useGetCompaniesSelectFilterQuery } from "../../features/api/apiSlice";

interface GlanceAdjustmentMarkCollectorProps {
  collectCallback: (data: GlanceAdjustmentMarkCollectModel) => Promise<boolean>;
}

export const GlanceAdjustmentMarkCollector = ({ collectCallback }: GlanceAdjustmentMarkCollectorProps) => {
  const [isCollecting, setIsCollecting] = useState(false);

  let model: GlanceAdjustmentMarkCollectModel = {
      symbols: [],
      authorization: ""
  };

  const onFinish = async (values: any) => {
    let collectModel: GlanceAdjustmentMarkCollectModel = {
      ...values
    };

    setIsCollecting(true);

    await collectCallback(collectModel);

    setIsCollecting(false);
  };

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
      <DefaultForm.DataSelect name="symbols" label="none" placeholder="انتخاب شرکت ها" multiple={true} recordId={x=>x.symbol} wrapperCol={{xs: 24, lg: 12}}
        query={useGetCompaniesSelectFilterQuery}
        displayText={(x) => `${x.symbol} (${x.name})`}
        isPersian={true}
      />

      <DefaultForm.TextInput name="authorization" wrapperCol={{xs: 24, md: 12, lg:6}} />

      <DefaultForm.SubmitButton loading={isCollecting} icon={<FontAwesomeIcon className="anticon" icon={faPlusCircle} />}>
          کالکت
      </DefaultForm.SubmitButton>
    </DefaultForm>
  );
};
